import React from 'react'
import { useState } from 'react';
import { LuFlaskConical, LuHospital } from 'react-icons/lu'; // , LuMapPin
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Turnstile } from '@marsidev/react-turnstile'
import { setContactinfo, setContacterror } from '../slices/contactSlice';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Contact() {
    const { csrfToken } = useCsrfToken();
    let params = useParams();
    let reflistingid = params.listingid;
    const dispatch = useDispatch();
    const contactInfo = useSelector((state) => state.contact.contactInfo);
    const contactError = useSelector((state) => state.contact.error);
    const [captchaPassed, setCaptchaPassed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorDeliveringMessage, SetErrorDeliveringMessage] = useState('');
    const [errorDelivering, SetErrorDelivering] = useState(false);
    const [successDeliveringMessage, SetSuccessDeliveringMessage] = useState('');
    const [successDelivering, SetSuccessDelivering] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    const TURNSTILE_KEY = '0x4AAAAAABBf7H_LASwjWDgk';

    const handlePhoneInput = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length > 10) {
            e.target.value = value.slice(0, 10);
        } else {
            e.target.value = value;
        }
    };

    const handleEmailInput = (e) => {
        const value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, '');
        e.target.value = value;

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
            e.target.setCustomValidity('Por favor, ingrese una dirección de correo electrónico válida.');
        } else {
            e.target.setCustomValidity('');
        }
    };

    const handleEmailBlur = (e) => {
        console.log('handleEmailBlur');
        const value = e.target.value;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const invalidFeedback = e.target.nextElementSibling;
        if (!emailPattern.test(value)) {
            e.target.setCustomValidity('Por favor, ingrese una dirección de correo electrónico válida.');
            invalidFeedback.style.display = 'block';
        } else {
            e.target.setCustomValidity('');
            invalidFeedback.style.display = 'none';
        }
    };

    const handleSanitizedInput = (e) => {
        let value = e.target.value;
        // Remove HTML tags
        value = value.replace(/<\/?[^>]+(>|$)/g, '');
        // Replace ENTER with a period and space
        value = value.replace(/\r?\n|\r/g, '. ');
        // Remove script tags
        value = value.replace(/<script.*?>.*?<\/script>/gi, 'HAPHAPHAP');
        // Remove any other unwanted characters or tags
        value = value.replace(/<[^>]*>/g, '');
        value = value.replace(/&[^;]+;/g, '');
        e.target.value = value;
    };

    const handleSanitizedTextarea = (e) => {
        let value = e.target.value;
        // Remove HTML tags
        value = value.replace(/<\/?[^>]+(>|$)/g, '');
        // Replace ENTER with a period and space
        value = value.replace(/\r?\n|\r/g, '. ');
        e.target.value = value;
    };

    const Initcontact = (data) => {
        // console.log('data', data);
        dispatch(setContactinfo(data));
    }

    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);

        const data = {
            name: formData.get('name'),
            lastname: formData.get('lastname'),
            tel: formData.get('tel'),
            email: formData.get('email'),
            comments: formData.get('comments'),
            captcharesponse: formData.get('cf-turnstile-response'),
            _token: csrfToken,
            listingid: reflistingid ? reflistingid : '',
        };
        Initcontact(data);

        try {
            const response = await fetch(`${API_URL}/api/sendmail/contact`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            if (result.status === 'success') {
                SetErrorDeliveringMessage('');
                SetErrorDelivering(false);
                SetSuccessDeliveringMessage(result.message);
                SetSuccessDelivering(true);
                dispatch(setContacterror(false));
                form.reset();
                setIsLoading(false);
            } else {
                SetErrorDeliveringMessage(result.message);
                SetErrorDelivering(true);
                SetSuccessDelivering(false);
                dispatch(setContacterror(true));
                setIsLoading(false);
            }
        } catch (error) {
            SetErrorDeliveringMessage(error);
            SetErrorDelivering(true);
            SetSuccessDelivering(false);
            dispatch(setContacterror(true));
            setIsLoading(false);
        }
    };

    const handleCallBackTurnstile = (data) => {
        setCaptchaPassed(true);
    }

    const handleExpirationTurnstile = () => {
        setCaptchaPassed(false);
        console.log('Turnstile - expired');
    }

    return (
        <>
            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-12 text-center py-3 mb-3">
                            <p className={'text-muted para-desc mx-auto'}>
                                En Hospital Aranda de la Parra, estamos listos para brindarte la atención que necesitas. Si tienes preguntas o requieres más información sobre nuestros servicios, no dudes en contactarnos.
                            </p>
                            <p className={'text-muted para-desc mx-auto'}>
                                Completa el siguiente formulario y nuestro equipo se pondrá en contacto contigo lo antes posible.
                            </p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="p-4 rounded shadow bg-inverted ms-lg-5">
                                <h4>Contáctanos</h4>
                                <form className="mt-4" onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold">Nombre(s) <span className="text-danger">*</span></label>
                                                <input name="name" id="name" type="text" className="form-control" placeholder="Su nombre:" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.name : ''} />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold">Apellido(s) <span className="text-danger">*</span></label>
                                                <input name="lastname" id="lastname" type="text" className="form-control" placeholder="Su(s) Apellido(s):" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.lastname : ''} />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold">Móvil a 10 dígitos <span className="text-danger">*</span></label>
                                                <input name="tel" id="tel" type="tel" className="form-control" placeholder="Teléfono móvil:" onInput={(e) => { handlePhoneInput(e); handleSanitizedInput(e); }} defaultValue={contactError ? contactInfo.tel : ''} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold">Correo electrónico <span className="text-danger">*</span></label>
                                                <input name="email" id="email" type="email" className="form-control" placeholder="Correo electrónico:" onInput={(e) => { handleEmailInput(e); handleSanitizedInput(e); }} onBlur={handleEmailBlur} defaultValue={contactError ? contactInfo.email : ''} />
                                                <div className="invalid-feedback">
                                                    Por favor, ingrese una dirección de correo electrónico válida.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold">Sus comentarios <span className="text-danger">*</span></label>
                                                <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Mensaje:" onInput={handleSanitizedTextarea} defaultValue={contactError ? contactInfo.comments : ''} ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <Turnstile siteKey={TURNSTILE_KEY} onSuccess={handleCallBackTurnstile} onExpire={handleExpirationTurnstile} />
                                        </div>
                                    </div>
                                    {captchaPassed && !isLoading && (
                                        <div className="row mt-2">
                                            <div className="col-12">
                                                <div className="d-grid">
                                                    <button type="submit" id="submit" name="send" className="btn btn-primary">Enviar Mensaje</button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {isLoading && (
                                        <div className="spinner-border text-success mx-auto my-2 text-center" role="status">
                                            <span className="visually-hidden text-center">Enviando, espere...</span>
                                        </div>
                                    )}
                                    {errorDelivering && (
                                        <div className="mt-5">
                                            <br />
                                            <div className="alert alert-warning text-dark alert-dismissible fade show" role="alert">
                                                <strong>No se pudo enviar su mensaje, error: </strong> {errorDeliveringMessage}
                                            </div>
                                        </div>
                                    )}
                                    {successDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                                <strong>{successDeliveringMessage}</strong>
                                            </div>
                                        </>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section bg-inverted">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="position-relative features text-center mx-lg-4 px-md-1">
                                <div className="position-relative d-flex justify-content-center">
                                    <LuHospital className="fea icon-md text-primary z-1" />
                                    {/* <div className="feature-icon bg-soft-primary position-absolute top-0 translate-middle"></div> */}
                                </div>

                                <div className="mt-4">
                                    <h5 className="mb-3">Hospital Centro</h5>
                                    <Link to="tel:+524777197100" className="text-primary">+52 (477) 719-7100</Link>
                                    <p className="text-muted mt-2">Hidalgo #329 Col. Centro, León Gto. 37000.</p>
                                    <Link to="https://maps.app.goo.gl/34PzFWjBqtGvspeb6" target='_blank' className="text-primary">Ver en Google Maps</Link>
                                    <h6 className="mb-3 mt-4">Urgencias</h6>
                                    <Link to="tel:+524777197101" className="text-primary">+52 (477) 719-7101</Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-5 pt-2 mt-md-0 pt-md-0 mb-5">
                            <div className="position-relative features text-center mx-lg-4 px-md-1">
                                <div className="position-relative d-flex justify-content-center">
                                    <LuHospital className="fea icon-md text-primary z-1" />
                                    {/* <div className="feature-icon bg-soft-primary position-absolute top-0 translate-middle"></div> */}
                                </div>

                                <div className="mt-4">
                                    <h5 className="mb-3">Hospital Puerto Interior</h5>
                                    <Link to="tel:+524725000000" className="text-primary">+52 (472) 500-0000</Link>
                                    <p className="text-muted mt-2">Blvd. Mineral de Cata #901 Esq Mineral de Rayas Puerto Interior, Silao Gto. 36275.</p>
                                    <Link to="https://maps.app.goo.gl/bBrRC3AHVasa5T136" target='_blank' className="text-primary">Ver en Google Maps</Link>
                                    <h6 className="mb-3 mt-4">Urgencias</h6>
                                    <Link to="tel:+524725000000" className="text-primary">+52 (472) 500-0000 ext. 8600</Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-5 pt-2 mt-md-0 pt-md-0">
                            <div className="position-relative features text-center mx-lg-4 px-md-1">
                                <div className="position-relative d-flex justify-content-center">
                                    <LuFlaskConical className="fea icon-md text-primary z-1" />
                                    {/* <div className="feature-icon bg-soft-primary position-absolute top-0 translate-middle"></div> */}
                                </div>

                                <div className="mt-4">
                                    <h5 className="mb-3">Laboratorios Clínicos</h5>
                                    {/* <h6 className="mt-3 text-muted">Sucursal Mariano Escobedo</h6>
                                    <p className="text-muted">Blvd. Mariano Escobedo #2402 Loc. 4 Col. León Moderno, León Gto. 37480.</p>
                                    <Link to="https://maps.app.goo.gl/HgNQ69hHYv5PnfJv5" target='_blank' className="text-primary">Ver en Google Maps</Link> */}
                                    <h6 className="mt-3 text-muted">Sucursal Centro</h6>
                                    <p className="text-muted">Hidalgo #329 Col. Centro, León Gto. 37000.</p>
                                    <Link to="https://maps.app.goo.gl/34PzFWjBqtGvspeb6" target='_blank' className="text-primary">Ver en Google Maps</Link>
                                    <h6 className="mt-3 text-muted">Sucursal Paseo del Moral</h6>
                                    <p className="text-muted">Blvd. Alonso de Torres Loc.B #1802 Col. Jardines del Moral, León Gto. 37125.</p>
                                    <p className='text-muted'>
                                        <Link to="tel:+524772519433" className="text-muted">+52 (477) 251-9433</Link>
                                    </p>
                                    <Link to="https://maps.app.goo.gl/efNbyoPwfPxSBzHr9" target='_blank' className="text-primary">Ver en Google Maps</Link>
                                    <h6 className="mt-3 text-muted">Sucursal Puerto Interior</h6>
                                    <p className="text-muted">Mineral de Cata 901, Polígono de Servicios Guanajuato Puerto Interior, Silao Gto. 36275.</p>
                                    <Link to="https://maps.app.goo.gl/bBrRC3AHVasa5T136" target='_blank' className="text-primary">Ver en Google Maps</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
